class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.predictiveSearchResultsInitial = this.querySelector('[data-predictive-search]').innerHTML;
    this.isOpen = false;
    this.clearBtn = this.querySelector('.js-search-clear');
    this.form = this.querySelector('form.search');
    this.openBtn = document.querySelector('.header__search summary')
    this.redirectResult = false
    this.noResults = false
    this.doneTyping = false
    this.setupEventListeners();
  }

  setupEventListeners() {
    const _this = this
    const btn = document.querySelector('.header__icon--search span');
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    const onChange = debounce(event => {
      this.onSearch(event)
    }, 300).bind(this);

    this.input.addEventListener('keydown', event => {
      if (event.code === "Enter" || event.key === "Enter") {
        if (!this.noResults && this.doneTyping) {
          this.redirectResult = true
          onChange(event)
        }
      }
    })

    this.input.addEventListener('input', onChange);

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.clearBtn.addEventListener('click', this.clearSearch.bind(this));
    btn.addEventListener('mousemove', this.onFocus.bind(this));
    this.input.addEventListener('keyup', this.setInputFocus.bind(this));
    this.openBtn.addEventListener('keyup', this.setInputFocus.bind(this));
    this.input.addEventListener('focusout', this.removeInputFocus.bind(this));


    const actions = ['resize', 'DOMContentLoaded']

    actions.forEach((action) => {
      window.addEventListener(action, () => {
        this.setForceAdapt(window.innerHeight < 900 && window.innerWidth < 989)
      })
    })
  }

  setForceAdapt(adapt, predictiveSearchResult = false) {
    const el = predictiveSearchResult ? predictiveSearchResult : this.predictiveSearchResults
    const elImages = el.querySelectorAll('.predictive-search-results-list__products-list .card__image img')

    // Get search result top
    const elClasses = el.classList
    const elRect = el.getClientRects()[0]
    const elHeight = window.innerHeight - elRect.top

    if (adapt) {
      elClasses.add('force-adapt')
      el.style.height = `${elHeight}px`
    } else {
      elClasses.remove('force-adapt')
      el.removeAttribute('style')
    }

    elImages.forEach((img) => {
      adapt ? img.classList.remove('fill') : img.classList.add('fill')
    })
  }

  setInputFocus(event) {
    if(event.shiftKey && event.key === 'Tab' || event.key === 'Tab') {
      this.form.classList.add('is-clicked');
    }
    this.doneTyping = false;
    let timer;
    clearTimeout(timer);

    timer = setTimeout(() => {
      this.doneTyping = true;
    }, 1000);
  }

  removeInputFocus() {
    this.form.classList.remove('is-clicked');
  }

  clearSearch(event) {
    event.stopPropagation();
    this.input.value = '';
    this.input.focus();
    this.predictiveSearchResults.innerHTML = this.predictiveSearchResultsInitial;
    trapFocus(this, this.input);
  }

  isMobileDevice() {
    return window.matchMedia("(max-width: 990px)").matches
  }

  getQuery() {
    return this.input.value.trim();
  }

  onSearch() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    if (this.redirectResult) {
      this.redirectSearchResultPage(searchTerm)
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFormSubmit(event) {
    event.preventDefault();
    document.activeElement.blur();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      if (!this.isMobileDevice()) this.getSearchResults(searchTerm);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const prevSelectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !prevSelectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && prevSelectedElement) {
      activeElement = prevSelectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = prevSelectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === prevSelectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (prevSelectedElement) prevSelectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResultData (searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const noResults = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('div[data-no-search-results]')?.getAttribute('data-no-search-results');

        this.noResults = noResults;

        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  redirectSearchResultPage (searchTerm) {
    fetch(`${routes.predictive_search_url}.json?q=${encodeURIComponent(searchTerm)}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.json();
      })
      .then((data) => {
        const results = data?.resources?.results || {}
        if (results?.collections?.length) {
          location.href = `/search?q=${encodeURIComponent(searchTerm)}`
        } else if (results?.queries?.length) {
          location.href = `/search?q=${encodeURIComponent(searchTerm)}`
        } else {
          location.href = `/search?_pos=1&_psq=${encodeURIComponent(searchTerm)}&_ss=e&_v=1.0&q=${encodeURIComponent(searchTerm)}`
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  getSearchResults(searchTerm) {
    this.getSearchResultData(searchTerm)
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    trapFocus(this, this.input);
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      this.removeAttribute('open');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
  }
}

customElements.define('predictive-search', PredictiveSearch);
